var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DividedList',{attrs:{"items":_vm.items,"list-item":_vm.MeetingListItem,"empty-message":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }